import React from 'react'
import { useNavigate } from "react-router-dom";
import { RiDiscountPercentLine } from "react-icons/ri";
import { Tooltip } from "primereact/tooltip";

const ComingsoonFooter = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    return (
        <div className="footerelement text-center">
          <ul>
            <li onClick={() => navigate("/terms-and-condition")}>
                Terms & Conditions
            </li>
            <li onClick={() => navigate("/privacy-policy")}>
                Privacy Policy
            </li>
            <li onClick={() => navigate("/cookie-policy")}>
                Cookie Policy
            </li>
          </ul>
          <p><small>© {currentYear} Graphē. All rights reserved.</small></p>
            <div className="join-float  join-btn" onClick={() => navigate("/waitlist")}>
                <RiDiscountPercentLine />
            </div>
            <Tooltip target=".join-btn" content="Join Waitlist" position="top" />
        </div>
    );
};

export default ComingsoonFooter